export const routesTanitim = [
  {
    path: "/odeme_yontemi",
    name: "odeme_yontemi",
    component: () => import("@/views/tanitim/odeme_yontemi/index.vue"),
    meta: {
      public: false,
      title: "Ödeme Yöntemleri",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/paket_tanitim",
    name: "paket_tanitim",
    component: () => import("@/views/tanitim/paket_tanitim/index.vue"),
    meta: {
      public: false,
      title: "Paket Tanıtım",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/dugun_tanitim",
    name: "dugun_tanitim",
    component: () => import("@/views/tanitim/dugun_tanitim/index.vue"),
    meta: {
      public: false,
      title: "Düğün Tanıtım",
      yetki: { k: [], a: true },
    },
  },
];
